<template>
    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-position="left" label-width="0px"  id="login_from" class="demo-ruleForm login-container" @keyup.native.enter="handleSubmit">
      <!--  <div class="left2">
            <div class="left2_box" >
                <img src="../assets/c1.png" style="width: 100%;height: 100%;margin-left: 5px;"/>
            </div>
        </div> -->
<!-- 			<img src="../assets/loginbg.png" style="width: 100%; height: 100%;"/> -->
	
        <div class="right1">
			
      <div class="right_box">
            <div  style="width: 68%;margin-left:15%;margin-top: 10%;" id="loginDiv">
                               <h3 class="title"><img src="../assets/home.png"  style="width: 100%;"/></h3>
                               <!--<el-select v-model="langVal" placeholder="" id="changeLangEvent" style="width: 100%; margin-left: 0px;" @change="changeLangEvent">-->
                               <!--<el-option-->
                               <!--v-for="item in options"-->
                               <!--:key="item.value"-->
                               <!--:label="item.label"-->
                               <!--:value="item.value">-->
                               <!--</el-option>-->
                               <!--</el-select>-->
                               <el-form-item prop="name" >
                                   <el-input type="text"  v-model="loginForm.name" id="loginName" auto-complete="off"  placeholder="帳號" ></el-input>
                               </el-form-item>
                               <el-form-item prop="password">
                                   <el-input type="password"  autocomplete="new-password" id="password" v-model="loginForm.password" auto-complete="off" placeholder="密碼"></el-input>
                               </el-form-item>
                               <el-checkbox v-model="checked"  class="remember">記住用戶名</el-checkbox>
                               <el-form-item style="width:100%;">
                                   <el-button type="primary" style="width:100%;background-color: #4B78FF"
                                              @click.native.prevent="handleSubmit" :loading="logining">登入</el-button>
                                   <!-- <el-button style="width:25%;" @click.native.prevent="handleReset" >重置</el-button> -->
                               </el-form-item>
                               <!--<el-form-item style="width:100%;" v-if="isShowChromeTip">-->
                                   <!--<p  style="color: #4B78FF;font-size: 15px; margin-top: -17px;text-align:center">{{$t('m.m_browser')}}【<a target="_blank" href="https://www.google.cn/chrome/" style="color:#4B78FF">{{$t('m.t_download')}}</a>】</p>-->
                               <!--</el-form-item>-->
                           </div>
        </div> 
        </div>
    
	
	</el-form>
</template>

<script>
    import { getToken } from '../api/api'
    import router from '@/router/router'
    import parseMenu from '@/utils/MenuUtil'
    export default {
        data() {
            var validateName=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error("帳號不能為空"));
                }else {
                    callback();
                }
            };
            var validatePwd=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error("密碼不能為空"));
                }else {
                    callback();
                }
            };
            return {
                options: [{
                    value: 'zh-CN',
                    label: '簡體'
                }, {
                    value: 'zh-TW',
                    label: '繁體'
                }, {
                    value: 'en-US',
                    label: 'English'
                }],
                langVal:"zh-CN",
                logining: false,
                loginForm: {
                    name: "",
                    password: ""
                },

                rules: {
                    name: [
                        { validator: validateName, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePwd, trigger: 'blur' }
                    ]
                },
                checked: false
            };
        },
        methods: {
            handleReset() {
                this.$refs.loginForm.resetFields();
            },
            handleSubmit(ev) {
                this.$router.options.routes =[];
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.logining = true;
                        var params={name:this.loginForm.name,password:this.loginForm.password};

                        getToken(params).then(
                            res=>{
                                //判斷核取方塊是否被勾選 勾選則調用配置cookie方法
                                if(this.checked){
                                    //傳入帳號名，密碼，和保存天數3個參數
                                    this.setCookie(this.loginForm.name,this.loginForm.password,7);
                                }else {
                                    this.clearCookie();
                                }
                                this.logining = false;


                                let {data:data={}}=res;
//                                console.log(data);
                                if(data.errcode===200){
                                    var isandroid = (/android/gi).test(navigator.appVersion); // 安卓
                                    var isiPhone = (/iphone/gi).test(navigator.appVersion); // ios
                                    var isiPad = (/ipad/gi).test(navigator.appVersion); // ipad
                                    if(isandroid||isiPhone||isiPad){
                                        //移动端登陆
                                        this.$store.commit("setIsmobilePhone",true);
                                    }else{
                                        this.$store.commit("setIsmobilePhone",false);
                                    }


                                    let {data:staff={}}=res.data;
                                    window.sessionStorage.setItem("staff",JSON.stringify(staff));       //將使用者存儲在session中
                                    let routes=[];
                                    parseMenu(routes,staff.menus);
                                    router.addRoutes(routes);
                                    this.$router.options.routes.push(...routes);
                                    this.$store.commit("updateStaff",staff);
                                    console.log(staff);
                                    this.$router.push({ path: '/' });
                                    this.$store.commit("clearTabs");
                                }else{
                                    this.$message.error(data.errmsg);
                                }
                            },
                            err=>{
                                this.logining = false;
                            }
                        );
                    }
                });
            },
            //設置cookie
            setCookie(c_name,c_pwd,exdays) {
                var exdate=new Date();//獲取時間
                exdate.setTime(exdate.getTime() + 7*24* 60 * 60 * 1000);//保存的天數
                //字串拼接cookie
                window.document.cookie="userName"+ "=" +c_name+";path=/;expires="+exdate.toGMTString();
                //window.document.cookie="userPwd"+"="+c_pwd+";path=/;expires="+exdate.toGMTString();
            },
            //讀取cookie
            getCookie:function () {
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//這裡顯示的格式需要切割一下自己可輸出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判斷查找相對應的值
                        if(arr2[0]=='userName'){
                            this.loginForm.name=arr2[1];//保存到保存資料的地方
                            this.checked=true;
                        }else {
                            this.checked=false;
                        }
                        /*if(arr2[0]=='userPwd'){
                            this.loginForm.password=arr2[1];
                            this.checked=true;
                        }else {
                            this.checked=false;
                        }*/
                    }
                }
            },
            getLangCoikieKey(){
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//這裡顯示的格式需要切割一下自己可輸出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判斷查找相對應的值
                        if(arr2[0]=='langKey'){
                            this.langVal=arr2[1];
                            this.$i18n.locale = arr2[1];//關鍵語句
                        }
                    }
                }
            },
            //清除cookie
            clearCookie:function () {
                this.setCookie("","",-1);//修改2值都為空，天數為負1天就好了
            },
            /**
             * 切換語言
             */
            changeLangEvent(val) {
                this.$i18n.locale = val;//關鍵語句
                var exdate=new Date();//獲取時間
                exdate.setTime(exdate.getTime() + 24*60*60*1000*7);//保存的天數
                window.document.cookie="langKey"+"="+val+";path=/;expires="+exdate.toGMTString();
                this.$refs.loginForm.validate((valid) => {});
            }
        },
        mounted() {
            //獲取cookie 記住用戶名細資訊
            this.getCookie();

            //獲取國際化語言
            this.getLangCoikieKey();

            var tags=document.getElementsByTagName("*");//獲取HTML的所有標籤
            for(var i in tags){//對標籤進行遍歷
                if(tags[i].nodeType==1){//判斷節點類型
                    if(tags[i].getAttribute("id") == "loginName")//判斷ID判斷控制項
                    {
                        tags[i].focus();
                        break;
                    }
                }
            }
        },
        computed:{
            isShowChromeTip() {
                var userAgent = navigator.userAgent; //取得流覽器的userAgent字串
                if (userAgent.indexOf("Chrome") > -1){
                    return false;
                }
                return true;
            }

        }
    }

</script>

<style lang="scss" scoped>
    /* #login_from input{
       width: 100%;
       border: none;
       border-bottom: 1px solid #ddd;
       background: none;
       color: #333;
       height: 50px;
       font-size: 16px;

     }
     #changeLangEvent{
         text-align: center;
     }*/
body
{
		// display: -webkit-box;
		// display: -webkit-flex;
		// display: flex;
		// -webkit-box-pack: center;
		// -webkit-justify-content: center;
		//         justify-content: center;
}
    body .el-select-dropdown__item{text-align: center}
    .left2{width: 50%;float: left;height: 100%; background: #4B78FF;}
    .left2 img{width:100%;}
    .left2_box{width: 68%;float: right;height: 70%; }
    .right1{
		
		// // background-color:white;
		 background-image:url(../assets/loginbg.png);
		 background-repeat: no-repeat;
		 background-size: cover;  
		    width: 100%;
		    height:100%;
		   
		 display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		        justify-content: center;
	
		}
    .right_box{
		
	background-color:white;//  display: flex;
	 position:absolute;
	 top:50%;
	 left:50%;
	 margin:-240px 0 0 -175px;
	 width:350px;
	 height:480px;
	 
	 // -webkit-box-pack: center;
	 // -webkit-justify-content: center;
	 //         justify-content: center;
	 
	 }
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/

        background-clip: padding-box;
        width: 100%;
        overflow: hidden;
        height: 100%;
        position: absolute;

        // .title {
        //     margin: 0px auto 40px -27px
        // ;
        //     text-align: center;
        //     color: #505458;
        // }
        .remember {
            margin: 15px 0px 25px 0px;
        }
    }

    .el-input__inner{padding: 0 5px;}
    .el-form-item__label{color: #000000;}
    // @media screen and (max-width: 1024px){

    //     .left2{display: none;}
    //     .right1{width:100%;}
    //     .right_box{width:100%;height:100%;margin:0px; background: #f9f9f9;}
    //     // #login_from{background: #00ffff;}
    //     #loginDiv h3{ margin-left: 1%;}
    // }
</style>




// WEBPACK FOOTER //
// src/views/Login.vue